import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import useReveal from "@/hooks/useReveal";

const contactEmail = "workwithdilip1@gmail.com";

const facts = [
    ["Positioning", "LÜVYN is an anti-swipe dating app focused on curated weekly matches and slower, more intentional conversation."],
    ["Core mechanic", "Five matches per week, selected across compatibility dimensions instead of an endless feed."],
    ["Trust stance", "Photo verification, hidden identity until useful, anti-ghosting nudges, and privacy-first defaults."],
    ["Launch state", "Alpha waitlist and brand site are being prepared before broader app availability."],
];

export default function Press() {
    useReveal();

    return (
        <div className="relative min-h-screen overflow-x-hidden" data-testid="press-page">
            <div className="grain" />
            <Header />
            <main id="top">
                <section className="relative pt-36 pb-20 lg:pt-44 lg:pb-28 bg-[var(--paper)]">
                    <div className="max-w-[1300px] mx-auto px-6 lg:px-10">
                        <div className="reveal in stamp stamp-large mb-8">
                            Press room
                        </div>
                        <h1 className="reveal in font-display text-[18vw] sm:text-[12vw] lg:text-[10rem] leading-[0.82] tracking-tighter">
                            The LÜVYN{" "}
                            <span className="font-italic-serif text-[var(--hot)]">
                                story.
                            </span>
                        </h1>
                        <p className="reveal in mt-8 max-w-2xl text-lg leading-relaxed text-[var(--ink-soft)]">
                            We do not have a separate press desk yet. For media,
                            creator, newsletter, or partnership questions, use the
                            same contact mailbox.
                        </p>
                    </div>
                </section>

                <section className="relative py-20 lg:py-28 bg-[var(--paper-2)] border-y-2 border-[var(--ink)]">
                    <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
                        <div className="reveal grid md:grid-cols-2 gap-5">
                            {facts.map(([title, copy]) => (
                                <article key={title} className="bg-[var(--paper)] border-2 border-[var(--ink)] p-7">
                                    <h2 className="font-display text-4xl leading-tight">
                                        {title}
                                    </h2>
                                    <p className="mt-4 leading-relaxed text-[var(--ink-soft)]">
                                        {copy}
                                    </p>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="relative py-20">
                    <div className="max-w-[1100px] mx-auto px-6 lg:px-10 border-y-2 border-[var(--ink)] py-10">
                        <div className="reveal font-mono text-[10px] uppercase tracking-[0.3em] text-[var(--hot)] mb-5">
                            Contact
                        </div>
                        <a
                            href={`mailto:${contactEmail}`}
                            className="reveal block font-display text-5xl lg:text-8xl leading-[0.9] hover:text-[var(--hot)] transition"
                        >
                            {contactEmail}
                        </a>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
